export interface MonthRange {
	monthStart: Date;
	monthEnd: Date;
	dateFromStr: string;
	dateToStr: string;
}

export function getMonthRange(month: string): MonthRange {
	const monthDate = new Date(`${month}-01T00:00:00`);
	const monthStart = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1);
	const monthEnd = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0, 23, 59, 59, 999);
	const lastDay = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 0);
	const dateFromStr = `${month}-01`;
	const dateToStr = `${month}-${String(lastDay.getDate()).padStart(2, '0')}`;
	return { monthStart, monthEnd, dateFromStr, dateToStr };
}

export function countDaysInMonth(eventFrom: Date, eventTo: Date, monthStart: Date, monthEnd: Date): number {
	const effectiveStart = eventFrom > monthStart ? eventFrom : monthStart;
	const effectiveEnd = eventTo < monthEnd ? eventTo : monthEnd;
	if (effectiveStart > effectiveEnd) return 0;

	const startDay = new Date(effectiveStart.getFullYear(), effectiveStart.getMonth(), effectiveStart.getDate());
	const endDay = new Date(effectiveEnd.getFullYear(), effectiveEnd.getMonth(), effectiveEnd.getDate());
	return Math.floor((endDay.getTime() - startDay.getTime()) / 86_400_000) + 1;
}

export function parsePriceToGrosze(value: string): number | null {
	if (value === '' || value == null) return null;
	const normalized = value.replace(/\s+/g, '').replace(',', '.');
	const n = Number(normalized);
	return Number.isFinite(n) ? Math.round(n * 100) : null;
}

export function bonusValueToGrosze(value: string): number {
	return Math.round(parseFloat(value) * 100);
}

export function extractErrorMessage(err: unknown, fallback: string): string {
	const e = err as { error?: { message?: string }; message?: string } | null;
	return e?.error?.message ?? e?.message ?? fallback;
}
